<template>
  <OmtLayoutContainer>
    <OmtRow mb="8px">
      <OmtTypography as="h1-regular"> <b>Envio das imagens</b> (opcional) </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography as="h3-bold" font-weight="600 !important"
        >Adicione imagens que ajudem na reanálise da sua reclamação:
      </OmtTypography>
    </OmtRow>

    <OmtRow>
      <ImageUploader @change="onImageUploaderChange" :length="limitFiles" :initialValue="pictures" />
    </OmtRow>

    <OmtRow :desktopStart="1" :desktopEnd="6" :gridRowStart="['initial', '2']">
      <CBox>
        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            <b>Arquivos suportados:</b> .jpg, .png, .heic e .pdf. com até 25mb.
          </OmtTypography>
        </CFlex>

        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            Envie apenas <b>um documento por foto</b>.
          </OmtTypography>
        </CFlex>

        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            Certifique-se de que todas as informações das imagens estão legíveis.
          </OmtTypography>
        </CFlex>
      </CBox>
    </OmtRow>

    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['100%', '308px !important']" @click="send">
        {{ isOtherMatters ? "Enviar" : "Continuar" }}
      </OmtButton>
    </OmtRow>
    <SentRequestModal
      :isOpen="modalSuccess"
      :isOuvidoria="true"
      :daysAnalizy="daysAnalizy"
      :protocol="protocolANS"
      @close="closeModal"
      @save="saveEvaluation"
    />
  </OmtLayoutContainer>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import ImageUploader from "@/components/Molecules/ImageUploader";
import SentRequestModal from "@/components/Organisms/Requests/SentRequestModal.vue";

export default {
  name: "UploadFileRequest",
  components: { ImageUploader, SentRequestModal },
  data() {
    return {
      pictures: [],
      requireAuth: true,
      daysAnalizy: "",
      modalSuccess: false,
      protocolANS: ""
    };
  },

  computed: {
    ...mapState("request", ["addPermission", "limitFiles", "newRequest", "subjectOptions"]),
    ...mapState("sac", ["newSolicitation"]),
    isOtherMatters() {
      return this.subjectOptions.find(s => s.value === this.newRequest.subject)?.outros || false;
    }
  },
  methods: {
    ...mapMutations("sac", ["SET_SUCCESS_REQUEST"]),
    ...mapActions("sac", ["fetchSolicitationReclamation"]),
    ...mapActions("ticket", ["saveExpRating"]),
    async send() {
      try {
        this.$root.$emit("show-loading");
        const response = await this.fetchSolicitationReclamation({
          protocolo: this.newSolicitation.protocolo,
          observacao: this.newSolicitation.observacao,
          anexosN: this.pictures
        });
        if (response) {
          this.daysAnalizy = response.validate;
          this.protocolANS = response.protocol;
          this.modalSuccess = true;
        }
      } finally {
        this.$root.$emit("hide-loading");
      }
    },
    closeModal() {
      this.modalSuccess = false;
      return;
    },
    async saveEvaluation({ rating, obs }) {
      await this.$root.$emit("show-loading");
      try {
        await this.saveExpRating({
          ticket: this.protocolANS,
          type: 12,
          step: "S",
          rating,
          obs
        });
      } finally {
        this.$root.$emit("hide-loading");
        this.SET_SUCCESS_REQUEST(true);
        this.$router.push("/ouvidoria");
      }
    },
    onImageUploaderChange(pictures) {
      this.pictures = pictures?.filter(pic => pic.source && pic.name) ?? [];
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>

<style scoped></style>
